import { useAgentEditorStore } from '@/state/root';
import { ImageType, Presenter } from '@d-id/types';
import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { PresenterAssetCard } from './PresenterAssetCard';

const PresenterSkeleton = styled(Skeleton)`
    aspect-ratio: 16/9;
    height: unset;
    position: relative;
    border-radius: 12px;
`;

interface Props {
    agentId?: string;
    presenters?: Presenter[];
    onClick: (item: Presenter) => void;
    onRemove: (item: Presenter) => void;
    selectedPresenter: Presenter | undefined;
    skeletonAmount?: number;
    setIsBackgroundsModalOpen: (isOpen: boolean) => void;
}

export const PresentersList = observer(
    ({ agentId, presenters, onClick, onRemove, selectedPresenter, setIsBackgroundsModalOpen, skeletonAmount = 29 }: Props) => {
        const agentEditorStore = useAgentEditorStore();

        if (!presenters) {
            return (
                <>
                    {Array.from({ length: skeletonAmount }, (_, index) => (
                        <PresenterSkeleton variant="rectangular" key={index} />
                    ))}
                </>
            );
        }

        return (
            <>
                {presenters.map(presenter =>
                    presenter.presenterType === ImageType.Skeleton ? (
                        <PresenterSkeleton key={presenter.id} variant="rectangular" />
                    ) : (
                        <PresenterAssetCard
                            agentId={agentId}
                            key={presenter.id}
                            presenter={presenter}
                            onClick={onClick}
                            onRemove={onRemove}
                            isBackgroundProcessing={agentEditorStore.backgroundProcessingPresenters.has(presenter?.id)}
                            setIsBackgroundsModalOpen={setIsBackgroundsModalOpen}
                            selectedPresenter={selectedPresenter}
                            showExpressiveTag
                        />
                    )
                )}
            </>
        );
    }
);
